/* eslint-disable max-len */
import React from 'react'

import detailServiceProduct from '../../constants/detail-service-product'
import premiumMassageImages from '../../static/images/massage/premium-massage'
import closeIcon from '../../static/icons/ic-close.svg'
import { TitleOne, TextBodyOne } from '../text'
import { Style } from './index.styles'
import CustomerCare from '../../constants/customer-care'

const { infoIcon, checkIcon, timeIcon, crossIcon } = premiumMassageImages
const {
  content_type: {
    DURATION,
    CHECKLIST,
    CROSS,
    BULLET,
    TOTAL_DURATION,
    DURATION_CHOICE,
    DURATION_WITH_SIZE,
    VENDOR_EQUIPMENT
  }
} = detailServiceProduct

const renderDivider = () => <div className="divider"></div>

const renderDurationChoice = itemContent => (
  <>
    <div className="container-duration">
      <TextBodyOne className="title-duration" display="block">
        {itemContent.title}
      </TextBodyOne>
      {itemContent.content.map(item => (
        <div key={item.id} className="content-duration">
          <div>
            <img
              src={timeIcon}
              alt="halojasa/info-icon"
              className="icon-images"
            />
          </div>
          <TextBodyOne className="text-subtitle" display="block">
            {item.title}
          </TextBodyOne>
        </div>
      ))}
    </div>
    {renderDivider()}
  </>
)

const renderBulletComponent = bulletComponent => (
  <div className="container-duration">
    <TextBodyOne className="title-duration" display="block">
      {bulletComponent.title}
    </TextBodyOne>
    {bulletComponent.detail_content.map(item => (
      <div key={item.id} className="content-duration">
        <div>
          <span className="circle-shape"></span>
        </div>
        <TextBodyOne className="text-subtitle" display="block">
          {item.title}
        </TextBodyOne>
      </div>
    ))}
  </div>
)

const renderCrossComponent = crossComponent => (
  <>
    <div className="container-duration">
      <TextBodyOne className="title-duration" display="block">
        {crossComponent.title}
      </TextBodyOne>
      {crossComponent.detail_content.map(item => (
        <div key={item.id} className="content-duration">
          <img
            src={crossIcon}
            alt="halojasa/info-icon"
            className="icon-images"
          />
          <TextBodyOne className="text-subtitle" display="block">
            {item.title}
          </TextBodyOne>
        </div>
      ))}
    </div>
    {renderDivider()}
  </>
)

const renderCheckComponent = checkComponent => (
  <>
    <div className="container-duration">
      <TextBodyOne className="title-duration" display="block">
        {checkComponent.title}
      </TextBodyOne>
      {checkComponent.detail_content.map(item => (
        <div key={item.id} className="content-duration">
          <img
            src={checkIcon}
            alt="halojasa/info-icon"
            className="icon-images"
          />
          <TextBodyOne className="text-subtitle" display="block">
            {item.title}
          </TextBodyOne>
        </div>
      ))}
    </div>
    {renderDivider()}
  </>
)

const renderVendorEquipmentItem = (firstIndex, lastIndex, detail_content) => {
  const items = []

  const maxIndex =
    lastIndex > detail_content.length ? detail_content.length : lastIndex

  for (let index = firstIndex; index < maxIndex; index++) {
    items.push(
      <div key={detail_content[index].id} className="content-duration">
        <img src={checkIcon} alt="halojasa/info-icon" className="icon-images" />
        <TextBodyOne className="text-subtitle" display="block">
          {detail_content[index].title}
        </TextBodyOne>
      </div>
    )
  }

  return items
}

const renderVendorEquipment = checkComponent => (
  <>
    <div className="container-duration">
      <TextBodyOne className="title-duration" display="block">
        {checkComponent.title}
      </TextBodyOne>
      <div className="container-vendor-equipment">
        <div>
          {renderVendorEquipmentItem(0, 6, checkComponent.detail_content)}
        </div>
        {checkComponent.detail_content.length > 6 && (
          <div className="sub-content-vendor-equipment">
            {renderVendorEquipmentItem(
              7,
              checkComponent.detail_content.length,
              checkComponent.detail_content
            )}
          </div>
        )}
      </div>
    </div>
    {renderDivider()}
  </>
)

const renderDurations = duration => (
  <>
    {duration.map(item => (
      <div key={item.id} className="container-duration">
        <TextBodyOne className="title-duration" display="block">
          {item.title}
        </TextBodyOne>
        <div className="content-duration">
          <img
            src={timeIcon}
            alt="halojasa/info-icon"
            className="icon-images"
          />
          <TextBodyOne className="title-duration" display="block">
            Duration : &nbsp;
          </TextBodyOne>
          <TextBodyOne className="text-subtitle" display="block">
            {item.subtitle}
          </TextBodyOne>
        </div>
      </div>
    ))}
    {renderDivider()}
  </>
)

const renderDurationWithSize = duration => (
  <>
    {duration.map(item => (
      <div key={item.id} className="container-duration">
        <TextBodyOne className="title-duration" display="block">
          {item.title}
        </TextBodyOne>
        <div className="content-duration-size">
          <TextBodyOne className="title-duration" display="block">
            Luas :&nbsp;
          </TextBodyOne>
          <TextBodyOne className="text-subtitle" display="block">
            {item.size}
          </TextBodyOne>
        </div>
        <div className="content-duration-size">
          <TextBodyOne className="title-duration" display="block">
            Duration :&nbsp;
          </TextBodyOne>
          <TextBodyOne className="text-subtitle" display="block">
            {item.subtitle}
          </TextBodyOne>
        </div>
      </div>
    ))}
    {renderDivider()}
  </>
)

const renderTotalDuration = (title, subtitle) => (
  <>
    <div className="container-duration">
      <TextBodyOne className="title-duration" display="block">
        {title}
      </TextBodyOne>
      <div className="content-duration">
        <img src={timeIcon} alt="halojasa/info-icon" className="icon-images" />
        <TextBodyOne className="text-subtitle" display="block">
          {subtitle}
        </TextBodyOne>
      </div>
    </div>
    {renderDivider()}
  </>
)

const renderAlertCard = ({ detailServiceProduct }) => (
  <div className="container-alert-card">
    <img src={infoIcon} alt="halojasa/info-icon" className="icon-images" />
    <TextBodyOne className="text-subtitle" display="block">
      {detailServiceProduct.alert_card}
    </TextBodyOne>
  </div>
)

const renderSubtitle = ({ detailServiceProduct }) => (
  <div className="container-subtitle">
    {detailServiceProduct.subtitle.map(item => (
      <TextBodyOne key={item} className="text-subtitle" display="block">
        {item}
      </TextBodyOne>
    ))}
  </div>
)

const renderTitle = ({ detailServiceProduct }) => (
  <TitleOne className="text-title" display="block">
    {detailServiceProduct.title}
  </TitleOne>
)

const renderDetailContent = ({ detailServiceProduct }) =>
  detailServiceProduct.content.map(itemContent => {
    if (itemContent.type === DURATION) {
      return (
        <div key={itemContent.id}>
          {renderDurations(itemContent.detail_content)}
        </div>
      )
    }

    if (itemContent.type === CHECKLIST) {
      return <div key={itemContent.id}>{renderCheckComponent(itemContent)}</div>
    }

    if (itemContent.type === CROSS) {
      return <div key={itemContent.id}>{renderCrossComponent(itemContent)}</div>
    }

    if (itemContent.type === BULLET) {
      return (
        <div key={itemContent.id}>{renderBulletComponent(itemContent)}</div>
      )
    }

    if (itemContent.type === TOTAL_DURATION) {
      return (
        <div key={itemContent.id}>
          {renderTotalDuration(itemContent.title, itemContent.subtitle)}
        </div>
      )
    }

    if (itemContent.type === DURATION_CHOICE) {
      return <div key={itemContent.id}>{renderDurationChoice(itemContent)}</div>
    }

    if (itemContent.type === DURATION_WITH_SIZE) {
      return (
        <div key={itemContent.id}>
          {renderDurationWithSize(itemContent.detail_content)}
        </div>
      )
    }

    if (itemContent.type === VENDOR_EQUIPMENT) {
      return (
        <div key={itemContent.id}>{renderVendorEquipment(itemContent)}</div>
      )
    }

    return null
  })

const renderContent = props => (
  <div className="sub-content">
    {renderTitle(props)}
    {renderSubtitle(props)}
    {renderAlertCard(props)}
    {renderDetailContent(props)}
  </div>
)

const renderButton = () => (
  <div className="container-button">
    <div className="content-button">
      <TextBodyOne
        className="text-button"
        display="block"
        onClick={() => {
          console.log('Testing')
          const baseUrl = window.location.href

          if (baseUrl.includes('massage')) {
            window.open(CustomerCare)
          } else {
            window.open('https://link.halojasa.com')
          }
        }}
      >
        Pesan Sekarang
      </TextBodyOne>
    </div>
  </div>
)

const renderTopContent = ({
  onCloseDetailServiceProduct,
  detailServiceProduct
}) => (
  <div className="container-top">
    <div className="container-close" onClick={onCloseDetailServiceProduct}>
      <img src={closeIcon} alt="halojasa/info-icon" className="icon-images" />
    </div>
    <div
      className="container-image-banner"
      style={{
        backgroundImage: `url(${detailServiceProduct.image})`
      }}
    />
  </div>
)

const renderContainer = props => (
  <div className="container-detail-service-product">
    <div className="content-detail-service-product">
      <div className="modal">
        {renderTopContent(props)}
        {renderContent(props)}
        {renderButton()}
      </div>
    </div>
  </div>
)

const DetailServiceProduct = props => <Style>{renderContainer(props)}</Style>

export default DetailServiceProduct
